<template>
	<div id="tabSettlement" class="page">
		<div v-if="balanceVisible" class="va-row mb-5" style="display: flex; justify-content: space-between;">
			<div class="flex md2 xs12">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.totalAmount' | translate}}</h5>
							<small>{{'t.processingFeeIncluded' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in totalAmount" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
			<div class="flex md2 xs12">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.netIncome' | translate}}</h5>
							<small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in netIncome" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
			<div class="flex md2 xs12">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.balance' | translate}}</h5>
							<small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in balance" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
			<div class="flex md2 xs12" v-if="settlementAmount">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.settlementAmount' | translate}}</h5>
							<small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in settlementAmount" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
			<div class="flex md2 xs12" style="position: relative;" v-if="payout">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.withdraw' | translate}}</h5>
							<small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in payout" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
					<div class="flex va-row mt-2">
						<button v-if="isShowPayout || isShowBank || isShowVA" class="btn btn-primary btn-micro" @click="createWithdraw" style="position:absolute;left:0;">
							<b>{{'t.createWithdraw' | translate}}</b>
						</button>
					</div>
				</vuestic-widget>
			</div>
      <div class="flex md2 xs12" v-if="reserveArray">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.reserve' | translate}}</h5>
              <small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in reserveArray" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
		</div>
		<tabs v-if="isShowListPayout || isShowListBank || isShowListVA" ref="financeTabs" :options="{ useUrlFragment: false }" @clicked="tabClicked" @changed="tabChanged">

			<tab v-if="isShowListPayout" :name="$t('t.payoutHistory')" id="payout-history">
				<div id="tabPayoutHistory" class="page invoice-wrap">
					<section class="flex md12 xs12">
						<div class="flex md12 xs12">
							<label class="select-title">{{ "t.createDate" | translate }}：</label>
							<date-picker v-model="payoutHistory.dates" range style="width: 240px;" :format="momentFormat"
								:placeholder="$t('finance.dateRangePlaceholder')"></date-picker>
							<el-button type="success" class="account-statement"
								@click="queryPayoutHistory">{{ $t('basic.button.search') }}</el-button>
						</div>
						<div class="dataGrid-report">
							<el-table :data="payoutHistory.tableData" tooltip-effect="light" class="dataGrid-report-table">
								<el-table-column min-width="240" prop="withdraw_id" :label="$t('t.id')"></el-table-column>
								<el-table-column min-width="150" prop="desc" :label="$t('t.remark')" show-overflow-tooltip></el-table-column>
								<el-table-column min-width="100" prop="request_currency" :label="$t('t.currency')"></el-table-column>
								<el-table-column min-width="150" prop="request_amount" :label="$t('tables.listing.amount')"></el-table-column>
								<el-table-column min-width="150" prop="create_time" :label="$t('tables.listing.recurring_create_time')"></el-table-column>
								<el-table-column prop="status" :label="$t('tables.listing.status')"></el-table-column>
							</el-table>
							<div class="block" v-show="payoutHistory.total > payoutHistory.pageSize">
								<pagination :total="payoutHistory.total" layout="total, sizes, prev, pager, next, jumper"
									background :page-size="payoutHistory.pageSize" :page.sync="payoutHistory.pageNum"
									:limit.sync="payoutHistory.pageSize" :page-sizes="[10, 50, 100]"
									@pagination="queryPayoutHistory" />
							</div>
						</div>
					</section>
				</div>
			</tab>

      <tab v-if="isShowListBank" :name="$t('finance.bankHistory')" id="bank-history">
        <bank-withdrawal ref="bankWithdrawalComponent" />
      </tab>

      <tab v-if="isShowListVA" :name="$t('finance.vaWalletHistory')" id="va-wallet-history">
        <virtual-account ref="virtualAccountComponent" />
      </tab>

		</tabs>

		<vuestic-modal :show.sync="withdrawDialogVisible" ref="withdraw" :okText="'modal.confirm2' | translate"
			style="height: 100%;width:60vw;" :okClass="'btn btn-primary btn-micro'"
			:cancelClass="'btn btn-secondary btn-micro'" :cancelText="'modal.cancel2' | translate" alignModal="" :large="true">
			<div slot="title">{{ $t("t.withdraw") }}</div>
      <tabs ref="withdrawTabs" :options="{ useUrlFragment: false }" @clicked="withdrawTabClicked" @changed="withdrawTabClicked">
        <tab v-if="isShowPayout" :name="$t('finance.toPayout')" id="to-payout">
          <form style="padding: 10px 20px;">
            <div class="va-row">
              <div class="flex xs12 md12">
                <fieldset class="withdraw-modal">
                  <div class="info-group">
                    <div class="form-group with-icon-right"
                      :class="{ 'has-error': initCurrencyVaild, 'valid': isCurrencyValid('currency') }">
                      <div class="input-group">
                        <vuestic-kyc-select id="currencyInput" name="currency" data-vv-as="Currency"
                          v-validate="'required'" required :label="$t('t.currency') + '：'"
                          v-model="withdrawData.currency" option-key="label" :options="currencies"
                          autocomplete="off"
                          @input="(val) => { currencyStatus = !val ? true : false; generateExchangeRate();updateArrivedCurrencyOption(val) }" />
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                        <i class="fa icon-right input-icon"></i>
                        <small v-show="initCurrencyVaild" class="help text-danger">{{
                          errors.first('currency') }}</small>
                      </div>
                    </div>
                    <div class="info-group-space"></div>
                    <div class="form-group with-icon-right withdraw-to-close">
                      <div class="input-group">
                        <vuestic-kyc-select :disabled="true" name="withdrawTo" data-vv-as="Withdraw to"
                          :label="`${$t('t.withdrawTo')}：`" v-model="withdrawTo" option-key="label"
                          :options="withdrawToOption" autocomplete="off" @input="withdrawToChange" />
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                        <i class="fa icon-right input-icon"></i>
                      </div>
                    </div>
                  </div>

                  <div class="info-group">
                    <div class="form-group with-icon-right" v-if="isBank">
                      <div class="input-group">
                        <input name="settlementFee" data-vv-as="Settlement Fee" v-model="settlementFee"
                          autocomplete="off" :disabled="true" />
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                        <i class="fa fa-check valid-icon icon-right input-icon"></i>
                        <label class="control-label" for="settlementFee">{{ "t.settlementFee" | translate }}</label>
                        <i class="bar"></i>
                      </div>
                    </div>
                    <div class="form-group with-icon-right withdraw-to-close" v-if="!isBank">
                      <div class="form-group with-icon-right"
                        :class="{ 'has-error': initPayoutAccounts, 'valid': isPayoutAccountsValid('payoutAccounts') }">
                        <div class="input-group">
                          <vuestic-kyc-select name="Payout Accounts" data-vv-as="Payout Accounts"
                            :label="$t('finance.payoutAccounts') + '：'" v-model="payoutAccounts"
                            option-key="account_name" option-value="account_id"
                            :options="payoutAccountsOptions" autocomplete="off" @input="(val) => {
                              payoutAccountsStatus = !val ? true : false; payoutAccountsChange(val)
                            }" />
                          <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                          <i class="fa icon-right input-icon"></i>
                          <small v-show="initPayoutAccounts" class="help text-danger">{{
                            errors.first('payoutAccounts') }}</small>
                        </div>
                      </div>
                    </div>
                    <div class="info-group-space"></div>
                    <div class="form-group with-icon-right"
                      :class="{ 'has-error': errors.has('amount'), 'valid': isFormFieldValid('amount') }"
                      v-if="isBank">
                      <div class="input-group">
                        <input name="amount" data-vv-as="Amount" v-model="withdrawData.amount"
                          autocomplete="off" v-validate="'required'" type="text" required
                          @input="changeAmountValue" />
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                        <i class="fa fa-check valid-icon icon-right input-icon"></i>
                        <label class="control-label" for="amount">{{ "t.amount" | translate }}</label>
                        <i class="bar"></i>
                        <small v-show="errors.has('amount')" class="help text-danger">{{
                          errors.first('amount') }}</small>
                      </div>
                    </div>
                    <div class="form-group with-icon-right withdraw-to-close" v-if="!isBank">
                      <div class="form-group with-icon-right"
                        :class="{ 'has-error': initArrivedCurrency, 'valid': isArrivedCurrencyValid('arrivedCurrency') }">
                        <div class="input-group">
                          <vuestic-kyc-select name="arrivedCurrency" data-vv-as="Arrived Currency"
                            :label="$t('finance.arrivedCurrency') + '：'" v-model="arrivedCurrency"
                            :options="arrivedCurrencyOption" autocomplete="off"
                            @input="(val) => { arrivedCurrencyStatus = !val ? true : false; arrivedCurrencyChange() }" />
                          <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                          <i class="fa icon-right input-icon"></i>
                          <small v-show="initArrivedCurrency" class="help text-danger">{{
                            errors.first('arrivedCurrency') }}</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-group" v-if="!isBank">
                    <div class="form-group with-icon-right"
                      :class="{ 'has-error': errors.has('amount'), 'valid': isFormFieldValid('amount') }">
                      <div class="input-group">
                        <input name="amount" data-vv-as="Amount" v-model="withdrawData.amount"
                          autocomplete="off" v-validate="'required'" type="text" required
                          @change="amountChange" @input="changeAmountValue" />
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                        <i class="fa fa-check valid-icon icon-right input-icon"></i>
                        <label class="control-label" for="amount">{{ "t.amount" | translate }}</label>
                        <i class="bar"></i>
                        <small v-show="errors.has('amount')" class="help text-danger">{{
                          errors.first('amount') }}</small>
                      </div>
                    </div>
                    <div class="info-group-space"></div>
                    <div class="form-group with-icon-right">
                      <div class="input-group">
                        <input name="arrivedAmount" data-vv-as="Arrived Amount" v-model="arrivedAmount"
                          autocomplete="off" :disabled="true" />
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                        <i class="fa fa-check valid-icon icon-right input-icon"></i>
                        <label class="control-label" for="arrivedAmount">{{ $t("finance.arrivedAmount") }}</label>
                        <i class="bar"></i>
                      </div>
                    </div>
                  </div>

                  <div class="info-group" v-show="!isBank">
                    <div class="form-group with-icon-right">
                      <div class="input-group">
                        <input name="exchangeRate" data-vv-as="exchangeRate" v-model="exchangeRate"
                          autocomplete="off" :disabled="true" />
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                        <i class="fa fa-check valid-icon icon-right input-icon"></i>
                        <label class="control-label" for="exchangeRate">{{ $t("finance.exchangeRate") }}</label>
                        <el-tooltip class="item" effect="light"
                          content="According to local regulations we need to take the funds outside the territory and bring them back for local payouts, because of that the available balance in local currency needs to be converted into USD, then back to the local currency. And the FX is applied during the conversion."
                          placement="right">
                          <i class="el-icon-question"></i>
                        </el-tooltip>
                        <i class="bar"></i>
                      </div>
                    </div>
                  </div>

                  <div class="info-group">
                    <div class="form-group with-icon-right"
                      :class="{ 'has-error': errors.has('remark'), 'valid': isFormFieldValid('remark') }">
                      <div class="input-group">
                        <textarea name="remark" data-vv-as="Remark" v-model="withdrawData.remark"
                          autocomplete="off" v-validate="'required'" maxlength="200" required />
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                        <i class="fa fa-check valid-icon icon-right input-icon"></i>
                        <label class="control-label" for="remark">{{ "t.remark" | translate }}</label>
                        <i class="bar"></i>
                        <small v-show="errors.has('remark')" class="help text-danger">{{
                          errors.first('remark') }}</small>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </form>
        </tab>
        <tab v-if="isShowBank" :name="$t('finance.toBank')" id="to-bank">
          <form style="padding: 0 20px 10px;">
            <!-- <p style="color: red;">Tips</p> -->
            <div class="va-row">
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right mb-2" :class="{ 'has-error': withdrawCurrencyStatus, 'valid': isWithdrawCurrencyValid('withdrawCurrency') }">
                  <div class="input-group">
                    <vuestic-kyc-select
                      class="withdraw-to-bank"
                      name="withdrawCurrency"
                      data-vv-as="Settlement Currency"
                      v-validate="'required'"
                      required
                      :label="$t('kyc.financial_infomation.settlement_currency') + '：'"
                      v-model="withdrawCurrency"
                      :options="withdrawToBankCurrencyOption" option-key="label"
                      autocomplete="off"
                      @input="(val) => {
                        withdrawCurrencyStatus = !val ? true : false;
                        withdrawCurrencyChange(val) }" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa icon-right input-icon"></i>
                    <small v-show="withdrawCurrencyStatus" class="help text-danger">{{ $t("finance.theSettlementCurrencyFieldIsRequired") }}</small>
                  </div>
                </div>
              </div>

              <div class="flex xs12 md6" v-if="withdrawCurrency && isUSDEUR">
                <div class="form-group with-icon-right mb-2" :class="{ 'has-error': withdrawToBankStatus, 'valid': isWithdrawToBankValid('withdrawToBank') }">
                  <div class="input-group">
                    <vuestic-kyc-select
                      class="withdraw-to-bank"
                      name="withdrawToBank"
                      data-vv-as="Settlement Bank Account"
                      v-validate="'required'"
                      required
                      :label="$t('finance.settlementBankAccount') + '：'"
                      v-model="withdrawToBank"
                      :options="withdrawToBankOption" option-key="label"
                      autocomplete="off"
                      @input="(val) => {
                        withdrawToBankStatus = !val ? true : false;
                        withdrawToBankChange(val) }" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa icon-right input-icon"></i>
                    <small v-show="withdrawToBankStatus" class="help text-danger">{{ $t("finance.theSettlementBankAccountFieldIsRequired") }}</small>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="withdrawCurrency">
              <!-- <h3 v-if="accountInfo.type">Account Info</h3> -->
              <div class="va-row" v-if="withdrawToBank">
                <!-- <div class="flex xs12 md4"><span>Method：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.type }} </b></div> -->
                <div class="flex xs12 md4"><span>Currency：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.currency }} </b></div>
                <div class="flex xs12 md4"><span>Account Number：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.account_number }} </b></div>
                <div class="flex xs12 md4"><span>Account Name：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.account_name }} </b></div>
                <div class="flex xs12 md4"><span>Bank Name：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.bank_name }} </b></div>
                <div class="flex xs12 md4"><span>Country：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.country }} </b></div>
                <div class="flex xs12 md4"><span>Branch：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.branch }} </b></div>
                <div class="flex xs12 md4"><span>SWIFT：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.swift_code }} </b></div>
                <div class="flex xs12 md4"><span>Address：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.address }} </b></div>
                <div class="flex xs12 md4"><span>IBAN：</span><b style="word-break: break-all;font-weight: bold;"> {{ accountInfo.iban }} </b></div>
              </div>
              <div class="va-row" v-for="(item, index) in bankWithdrawData" :key="index">
                <div class="flex xs12 md3">
                  <div class="form-group with-icon-right" :class="{ 'has-error': item[`bankCurrencyStatus${index}`], 'valid': isBankCurrencyValid(item) }">
                    <div class="input-group">
                      <vuestic-kyc-select
                        class="withdraw-tobank-currency"
                        :name="`Currency ${index}：`"
                        :data-vv-as="`Currency ${index}：`"
                        v-validate="'required'" required :label="$t('t.currency') + '：'"
                        v-model="item['currency']" option-key="label" :options="newCurrencies"
                        autocomplete="off"
                        @input="(val) => {
                          item[`bankCurrencyStatus${index}`] = !val ? true : false;
                          item['balance'] = val.balance
                          // $validator.validate(`bankAmountWithdraw${index}`);
                        }" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa icon-right input-icon"></i>
                      <small v-if="item[`bankCurrencyStatus${index}`]" class="help text-danger">The Currency {{ index + 1 }} field is required.</small>
                    </div>
                  </div>
                </div>
                <div class="flex xs12 md2">
                  <div class="form-group with-icon-right" style="padding-top: 8px;">
                    <div class="input-group">
                      <input name="Balance" data-vv-as="Balance" v-model="item['balance']" autocomplete="off" :disabled="true" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label" for="bank-balance">{{ $t("t.balance") }}</label>
                      <i class="bar"></i>
                    </div>
                  </div>
                </div>
                <div class="flex xs12 md4">
                  <div class="form-group with-icon-right" :class="{ 'has-error': errors.has(`bankAmountWithdraw${index}`), 'valid': isFormFieldValid(`bankAmountWithdraw${index}`) }" style="padding-top: 8px;">
                    <div class="input-group">
                      <!-- oninput='value = value.replace(/[^\d.]/g, "");value = value.replace(/^ ./g, "");value = value.replace(/\.{2,}/g, ".");value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");value = value.replace(/^(\-)*(\d+).(\d\d).*$/, "$1$2.$3");' -->
                      <input
                        :name="`bankAmountWithdraw${index}`"
                        :data-vv-as="`Amount for Withdrawal ${index + 1}`"
                        v-model="item['amount']" autocomplete="off" v-validate="`required|verifyWithdrawAmount:${index}`" type="text" required
                        oninput="if(!value){value=''}else if(value.charAt(0)==='0'&&value.charAt(1)&&value.charAt(1)!=='.'){value='0'};value = value.replace(/[^\d.]/g, '');value=value.replace(/\.{2,}/g, '.');value=value.match(/^\d*(\.?\d{0,2})/g)[0] || '';"
                      />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label" for="bankAmountWithdraw">{{ $t("finance.amountForWithdrawal") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has(`bankAmountWithdraw${index}`)" class="help text-danger">{{
                        errors.first(`bankAmountWithdraw${index}`) }}</small>
                    </div>
                  </div>
                </div>
                <div class="flex xs12 md3" v-if="isUSDEUR">
                  <div class="form-group with-icon-right" style="padding-top: 8px;">
                    <div class="input-group">
                      <button class="btn btn-primary btn-micro" type="button" style="margin-right: 10px;" @click="addBankCurrency(index)" v-if="(bankWithdrawData.length-1) === index">
                        <i class="fa fa-plus"></i>
                      </button>
                      <button class="btn btn-primary btn-micro" type="button" v-if="bankWithdrawData.length > 1" @click="minusBankCurrency(index)">
                        <i class="fa fa-minus"></i>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
              <div class="va-row">
                <div class="flex xs12 md12">
                  <div class="form-group with-icon-right"
                    :class="{ 'has-error': errors.has('bankRemark'), 'valid': isFormFieldValid('bankRemark') }">
                    <div class="input-group">
                      <textarea name="bankRemark" data-vv-as="BankRemark" v-model="bankRemark"
                        autocomplete="off" v-validate="'required'" maxlength="200" required />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label" for="bankRemark">{{ "t.remark" | translate }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('bankRemark')" class="help text-danger">{{
                        errors.first('bankRemark') }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </tab>
        <tab v-if="isShowVA" :name="$t('finance.toVAWallet')" id="to-va-wallet">
          <form style="padding: 10px 20px;">
            <div class="va-row">
              <div class="flex xs12 md6">
                <div class="form-group with-icon-right mb-2" :class="{ 'has-error': errors.has('virtualAccount'), 'valid': isFormFieldValid('virtualAccount') }">
                  <div class="input-group">
                    <input name="virtualAccount" data-vv-as="VA Wallet Address" v-model="virtualAccount"
                      autocomplete="off" v-validate="'required'" type="text" required onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" for="virtualAccount">{{ $t("finance.vaWalletAddress") }}</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('virtualAccount')" class="help text-danger">{{
                      errors.first('virtualAccount') }}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="va-row" v-for="(item, index) in virtualAccountData" :key="index">
              <div class="flex xs12 md3">
                <div class="form-group with-icon-right" :class="{ 'has-error': item[`accountCurrencyStatus${index}`], 'valid': isAccountCurrencyValid(item) }">
                  <div class="input-group">
                    <vuestic-kyc-select
                      class="withdraw-tobank-currency"
                      :name="`Currency ${index}：`"
                      :data-vv-as="`Currency ${index}：`"
                      v-validate="'required'" required :label="$t('t.currency') + '：'"
                      v-model="item['currency']" option-key="label" :options="newAccountCurrencies"
                      autocomplete="off"
                      @input="(val) => {
                        item[`accountCurrencyStatus${index}`] = !val ? true : false;
                        item['balance'] = val.balance
                        // $validator.validate(`accountAmountWithdraw${index}`);
                      }" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa icon-right input-icon"></i>
                    <small v-if="item[`accountCurrencyStatus${index}`]" class="help text-danger">The Currency {{ index + 1 }} field is required.</small>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md2">
                <div class="form-group with-icon-right" style="padding-top: 8px;">
                  <div class="input-group">
                    <input name="Balance" data-vv-as="Balance" v-model="item['balance']" autocomplete="off" :disabled="true" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" for="bank-balance">{{ $t("t.balance") }}</label>
                    <i class="bar"></i>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md4">
                <div class="form-group with-icon-right" :class="{ 'has-error': errors.has(`accountAmountWithdraw${index}`), 'valid': isFormFieldValid(`accountAmountWithdraw${index}`) }" style="padding-top: 8px;">
                  <div class="input-group">
                    <!-- oninput='value = value.replace(/[^\d.]/g, "");value = value.replace(/^ ./g, "");value = value.replace(/\.{2,}/g, ".");value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");value = value.replace(/^(\-)*(\d+).(\d\d).*$/, "$1$2.$3");' -->
                    <input
                      :name="`accountAmountWithdraw${index}`"
                      :data-vv-as="`Amount for Withdrawal ${index + 1}`"
                      v-model="item['amount']" autocomplete="off" v-validate="`required|verifyVAWithdrawAmount:${index}`" type="text" required
                      oninput="if(!value){value=''}else if(value.charAt(0)==='0'&&value.charAt(1)&&value.charAt(1)!=='.'){value='0'};value = value.replace(/[^\d.]/g, '');value=value.replace(/\.{2,}/g, '.');value=value.match(/^\d*(\.?\d{0,2})/g)[0] || '';"
                    />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" for="accountAmountWithdraw">{{ $t("finance.amountForWithdrawal") }}</label>
                    <i class="bar"></i>
                    <small v-show="errors.has(`accountAmountWithdraw${index}`)" class="help text-danger">{{
                      errors.first(`accountAmountWithdraw${index}`) }}</small>
                  </div>
                </div>
              </div>
              <div class="flex xs12 md3">
                <div class="form-group with-icon-right" style="padding-top: 8px;">
                  <div class="input-group">
                    <button class="btn btn-primary btn-micro" type="button" style="margin-right: 10px;" @click="addAccountCurrency(index)" v-if="(virtualAccountData.length-1) === index">
                      <i class="fa fa-plus"></i>
						        </button>
                    <button class="btn btn-primary btn-micro" type="button" v-if="virtualAccountData.length > 1" @click="minusAccountCurrency(index)">
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                </div>
              </div>

            </div>
            <div class="va-row">
              <div class="flex xs12 md12">
                <div class="form-group with-icon-right"
                  :class="{ 'has-error': errors.has('accountRemark'), 'valid': isFormFieldValid('accountRemark') }">
                  <div class="input-group">
                    <textarea name="accountRemark" data-vv-as="AccountRemark" v-model="accountRemark"
                      autocomplete="off" v-validate="'required'" maxlength="200" required />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" for="accountRemark">{{ "t.remark" | translate }}</label>
                    <i class="bar"></i>
                    <small v-show="errors.has('accountRemark')" class="help text-danger">{{
                      errors.first('accountRemark') }}</small>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </tab>
      </tabs>
		</vuestic-modal>
	</div>
</template>

<script>
import Vue from "vue";
import "../../tabs/tabs-component.css";
import { Tabs, Tab } from "vue-tabs-component";
import Pagination from "../Pagination/index";
import BigNumber from "bignumber.js/bignumber.mjs";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import qs from "qs";
import { request, formatDate2Day, getStartDateOf1Month } from "@/utils/utils";
var moment = require("moment-timezone");
import BankWithdrawal from "@/components/FinancialManagementNew/components/BankWithdrawal"
import VirtualAccount from "@/components/FinancialManagementNew/components/VirtualAccount"

import mixin from './mixins/ToVirtualAccountMixins'

Vue.component("tabs", Tabs);
Vue.component("tab", Tab);
export default {
	name: "financial-management",
  mixins: [mixin],
	data() {
    this.$validator.extend('verifyWithdrawAmount', {
      validate: (value, ref) => {
        const data = this.bankWithdrawData[ref[0]]
        if (!data.currency) {
          return true
        }
        if (Number(value) > data.balance) {
          return false
        }
        return true
      },
      getMessage: (field) => 'The withdrawal amount should be less than the balance'
    })
		return {
      isShowListPayout: false,
      isShowListBank: false,
      isShowListVA: false,
      isShowPayout: false,
      isShowBank: false,
      isShowVA: false,
			balanceVisible: false,
			totalAmount: [],
			netIncome: [],
			balance: [],
      settlementAmount: undefined,
			payout: undefined,
			settlementFees: [],
      reserveArray: undefined,
			settlementFee: 'Not set',
			currencies: [],
			momentFormat: "", // 默认是一个字符串
			// {
			// 	stringify: date => {
			// 		return date ? moment(date).format("YYYY-MM-DD") : "";
			// 	},
			// 	parse: value => {
			// 		return value ? moment(value, "YYYY-MM-DD").toDate() : null;
			// 	}
			// },
			currTimeZone: "America/Sao_Paulo",
			payoutHistory: {
				total: 0,
				pageNum: 1,
				pageSize: 10,
				dates: [getStartDateOf1Month(), formatDate2Day(new Date())],
				tableData: []
			},
			currentSelectedDetail: [
				{ 2: "DESCRIPTION", 16: "AMOUNT", 20: "SETTLEMENT AMOUNT" }
			],
			// withdraw 功能
			withdrawDialogVisible: true,
			withdrawData: {
				currency: '',
				amount: '',
				fee_currency: '',
				fee_amount: '',
			},
			currencyStatus: false,
			payoutAccountsStatus: false,
			arrivedCurrencyStatus: false,
			withdrawTo: { label: 'Payout Balance', value: 'Payout Balance' },// { label: 'Bank', value: 'Bank' }, // Settlement Bank Account
			withdrawToOption: [
				// { label: 'Bank', value: 'Bank' },
				{ label: 'Payout Balance', value: 'Payout Balance' }
			],
			payoutAccounts: {},
			payoutAccountsOptions: [],
			arrivedCurrency: '',
			arrivedCurrencyOption: [],
			arrivedAmount: "",
			exchangeRate: "",
			withdrawToken: "",
			otherPayoutBean: {},
			isBank: false,
			isPayout: true,
      // bank withdraw
      withdrawToBankOption: [],
      withdrawCurrency: '',
      withdrawToBank: '',
      withdrawCurrencyStatus: false,
      withdrawToBankStatus: false,
      bankWithdrawData: [{ bankCurrencyStatus: false }],
      bankRemark: '',
      accountInfo: {},
      currentSelectedTab: '',
      currentWithdrawSelectedTab: '',
      isUSDEUR: true
		};
	},
	components: {
		Pagination,
		DatePicker,
    BankWithdrawal,
    VirtualAccount
	},
	computed: {
		isMobile: function () {
			if (document.body.clientWidth && document.body.clientWidth < 750) {
				return "mobile";
			}
			return "pc";
		},
		initCurrencyVaild: function () {
			return this.currencyStatus
		},
		initPayoutAccounts: function () {
			return this.payoutAccountsStatus
		},
		initArrivedCurrency: function () {
			return this.arrivedCurrencyStatus
		},
    initWithdrawCurrencyValid: function () {
			return this.withdrawCurrencyStatus
		},
    initWithdrawToBankVaild: function () {
			return this.withdrawToBankStatus
		},
    newAccountCurrencies() {
      return this.currencies.filter(currency => {
        return !(this.virtualAccountData.some(bank => {
          if (bank.currency) {
            return bank.currency.value === currency.value
          } else {
            return false
          }
        }))
      })
    },
    newCurrencies() {
      return this.currencies.filter(currency => {
        return !(this.bankWithdrawData.some(bank => {
          if (bank.currency) {
            return bank.currency.value === currency.value
          } else {
            return false
          }
        }))
      })
    },
    withdrawToBankCurrencyOption() {
      let currenciesArray = this.currencies.map(currency => {
        return { label: currency.value, value: currency.value }
      })
      const usdEur = [ { label: 'USD', value: 'USD' }, { label: 'EUR', value: 'EUR' } ]
      usdEur.forEach(u => {
        let isExist = currenciesArray.some(c => { return c.value === u.value })
        if (!isExist) {
          currenciesArray = currenciesArray.concat({ label: u.value, value: u.value })
        }
      })
      return currenciesArray
    }
	},
	mounted() {
		this.init();
    // console.log("financeTabs", this.$refs.financeTabs.selectTab('#to-bank'))
	},
	watch: {
		'withdrawData.currency'() {
			const fee = this.settlementFees[this.withdrawData.currency.value]
			if (fee) {
				const amount = this.settlementFees[this.withdrawData.currency.value].amount
				const currency = this.settlementFees[this.withdrawData.currency.value].currency
				this.settlementFee = `${amount} ${currency}`
				this.withdrawData.fee_amount = amount
				this.withdrawData.fee_currency = currency
			} else {
				this.settlementFee = 'Not set'
			}
		},
	},
	methods: {
		init() {
			this.queryRevenueList();
		},
		formatAmount(num) {
			if (num === 0) {
				return 0;
			}
			let str = new BigNumber(String(num));
			return str.toFormat(2);
		},
		getJsonKey(json) {
			for (var name in json) {
				return name;
			}
		},
		getJsonValue(json) {
			for (var name in json) {
				return json[name];
			}
		},
		dateFormat(value, formatStr = "YYYY-MM-DD HH:mm:ss") {
			return moment
				.tz(moment.tz(value, "UTC"), this.currTimeZone)
				.format(formatStr);
		},
		stringifyDate(date) {
			return date ? moment(date).format("YYYY-MM-DD") : "";
		},
		queryRevenueList() {
			let queryParameters = {
				access_token: localStorage.getItem("Authorization")
			}
			request({
				method: "post",
				url: "api/dashboard/merchant/assets/detail",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
					let data = res.data;
					if (data.code === '10000') {
						this.balanceVisible = true
            // data.data.to_va_list = true // test
            // data.data.to_va = true // test
            const { to_payout_list, to_bank_list, to_va_list, to_payout, to_bank, to_va, total_amount, net_income, balance, settlement_amount, payout, settlement_fee, reserve } = data.data
            this.isShowListPayout = to_payout_list
            this.isShowListBank = to_bank_list
            this.isShowListVA = to_va_list
            this.isShowPayout = to_payout
            this.isShowBank = to_bank
            this.isShowVA = to_va
						this.totalAmount = total_amount
						this.netIncome = net_income
						this.balance = balance
            this.settlementAmount = settlement_amount
						this.payout = payout
						this.settlementFees = settlement_fee
            this.reserveArray = reserve

						this.currencies = []
						for (var item of this.balance) {
							for (var key in item) {
								const currency = {
									value: key,
									label: `${key}(${item[key]})`,
                  balance: item[key]
								}
								this.currencies.push(currency)
							}
						}

            const that = this
            if (this.isShowListPayout) {
              this.currentSelectedTab = 'payout-history'
              // that.$nextTick(() => {
              //   that.$refs.financeTabs.selectTab('#payout-history')
              // })
            } else if (this.isShowListBank) {
              this.currentSelectedTab = 'bank-history'
              // that.$nextTick(() => {
              //   that.$refs.financeTabs.selectTab('#bank-history')
              // })
            } else if (this.isShowListVA) {
              this.currentSelectedTab = 'va-wallet-history'
              // that.$nextTick(() => {
              //   that.$refs.financeTabs.selectTab('#va-wallet-history')
              // })
            }
					}
				})
				.catch(err => { });
		},
		queryPayoutHistory() {
			this.$set(this.payoutHistory, "tableData", []);
			let queryParameters = {
				access_token: localStorage.getItem("Authorization"),
				start_date: this.stringifyDate(this.payoutHistory.dates[0]) + ' 00:00:00',
				end_date: this.stringifyDate(this.payoutHistory.dates[1]) + ' 23:59:59',
				page_num: this.payoutHistory.pageNum,
				page_size: this.payoutHistory.pageSize,
				currency: ''
			};
      this.loadingFullScreen('withdrawListLoading', 'loading', 'fa fa-hourglass-half')
			request({
				method: "post",
				url: "api/dashboard/merchant/assets/withdraw/list",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
          this.withdrawListLoading.close()
					let data = res.data;
					if (data.code !== '10000') {
						return;
					}
					this.$set(this.payoutHistory, "total", data.data.total);

					if (data.data.list.length > 0) {
						let lists_tr = data.data.list.map(v => {
							if (v.desc) {
								v.desc = JSON.parse(v.desc).remark
							}
							return v;
						})
						this.$set(this.payoutHistory, "tableData", lists_tr);
					} else {
						return;
					}
				})
				.catch(err => { this.withdrawListLoading.close() });
		},
		tabChanged(selectedTab) {
      this.currentSelectedTab = selectedTab.tab.id || selectedTab.tab.computedId
			if (this.currentSelectedTab === 'payout-history') {
				this.queryPayoutHistory();
			} else if (this.currentSelectedTab === 'bank-history') {
				this.$refs.bankWithdrawalComponent.queryBankWithdrawal()
			} else if (this.currentSelectedTab === 'va-wallet-history') {
				this.$refs.virtualAccountComponent.queryBankWithdrawal()
			}
		},
		tabClicked(selectedTab) {
      this.currentSelectedTab = selectedTab.tab.id || selectedTab.tab.computedId
			if (this.currentSelectedTab === 'payout-history') {
				this.queryPayoutHistory();
			} else if (this.currentSelectedTab === 'bank-history') {
				this.$refs.bankWithdrawalComponent.queryBankWithdrawal()
			} else if (this.currentSelectedTab === 'va-wallet-history') {
				this.$refs.virtualAccountComponent.queryBankWithdrawal()
			}
		},
    withdrawTabClicked(selectedTab) {
      this.resetToBankForm()
      this.currentWithdrawSelectedTab = selectedTab.tab.id || selectedTab.tab.computedId
      if (this.currentWithdrawSelectedTab === 'to-bank') {
        this.withdrawToBankUniqueOne()
      }
    },
    withdrawToBankRequest(params) {
      const that = this;
      that.loadingFullScreen('withdrawToBankLoading', 'loading', 'fa fa-hourglass-half')
      const access_token = localStorage.getItem("Authorization")
      request({
        method: "post",
        url: `api/dashboard/merchant/assets/batch-withdraw?access_token=${access_token}`,
        data: params,
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(res => {
          that.withdrawToBankLoading.close()
          let data = res.data;
          if (data.code === "10000") {
            that.resetToBankForm()
            that.$message({
              type: "success",
              duration: 5000,
              message: data.msg
            });
            that.$refs.withdraw.close()
            that.queryRevenueList();
            that.$refs.financeTabs.selectTab('#bank-history')
          // } else if (data.code === "20010") {
          //   that.$message({ type: "error", duration: 5000, message: 'The amount you specified for withdrawal is less than minimum amount. Please double check the amount and try again.' });
          } else {
            that.$message({ type: "error", duration: 5000, message: data.msg });
          }
        })
        .catch(err => { });
    },
    resetToBankForm() {
      this.bankWithdrawData = [{ bankCurrencyStatus: false }]
      this.virtualAccountData = [{ accountCurrencyStatus: false }]
      this.withdrawCurrencyStatus = false
      this.withdrawToBankStatus = false
      this.bankRemark = ''
      this.accountRemark = ''
      this.accountInfo = {}
      this.withdrawCurrency = ''
      this.withdrawToBank = ''
      this.virtualAccount = ''
    },
		// withdraw 功能
		createWithdraw() {
			// 获取数据
      // to payout
			this.fetchPayoutAccounts()
      // to bank
      this.fetchBankAvailableList()

			this.isBank = false
      this.isPayout = true
			this.withdrawDialogVisible = true;
			this.$refs.withdraw.open()
			this.$validator.reset()
			this.withdrawData = {
				currency: '',
				amount: '',
				fee_currency: '',
				fee_amount: '',
				remark: ''
			}
			this.withdrawTo = { label: 'Payout Balance', value: 'Payout Balance' } // { label: 'Bank', value: 'Bank' }
			this.settlementFee = 'Not set';
			this.arrivedCurrencyOption = []
			this.arrivedCurrency = ''

      // 确认功能
      let that = this
      if (that.currentSelectedTab === 'bank-history') {
        that.currentWithdrawSelectedTab = 'to-bank'
        that.$refs.withdrawTabs.selectTab('#to-bank')
        that.resetToBankForm()
      } else if (that.currentSelectedTab === 'va-wallet-history') {
        that.currentWithdrawSelectedTab = 'to-va-wallet'
        that.$refs.withdrawTabs.selectTab('#to-va-wallet')
        that.resetToBankForm()
      } else {
        that.currentWithdrawSelectedTab = 'to-payout'
        that.$refs.withdrawTabs.selectTab('#to-payout') // Payout History To Payout
      }
			that.$refs.withdraw.ok = () => {
        // 根据当前的表单走不同的逻辑
        if (that.currentWithdrawSelectedTab === 'to-bank') {
          const validateData = { bankRemark: that.bankRemark }
          that.bankWithdrawData.forEach((bank,index) => {
            if (bank.currency) {
              bank[`bankCurrencyStatus${index}`] = false
            } else {
              bank[`bankCurrencyStatus${index}`] = true
            }
            validateData[`bankAmountWithdraw${index}`] = bank.amount
          })
          that.$validator.validateAll(validateData).then((result) => {
            if (that.withdrawCurrency === '') {
              that.withdrawCurrencyStatus = true
            } else {
              that.withdrawCurrencyStatus = false
            }
            if (that.isUSDEUR && that.withdrawToBank === '') {
              that.withdrawToBankStatus = true
            } else {
              that.withdrawToBankStatus = false
            }
            const isAllCurrencyFalse = that.bankWithdrawData.every((bank,index) => !bank[`bankCurrencyStatus${index}`])
            if (!isAllCurrencyFalse || that.withdrawCurrency === '' || (that.isUSDEUR && that.withdrawToBank === '')) { return }
            // 每个 balance 都要大于 amount
            const isAllLessBalance = that.bankWithdrawData.every((bank,index) => {
              return Number(bank.balance) >= Number(bank.amount)
            })
            if (!isAllLessBalance) { return }
            if (result) {
              const params = {
                "withdraw_currency": that.withdrawCurrency.value,
                "remark": that.bankRemark,
                "withdraw_requests": []
              }
              if (that.withdrawCurrency.value === 'USD' || that.withdrawCurrency.value === 'EUR') {
                params.bank_account_id = that.withdrawToBank.id
              }
              params.withdraw_requests = that.bankWithdrawData.map(item => {
                return { amount: item.amount, currency: item.currency.value }
              })
              that.withdrawToBankRequest(params)
            }
          })
          return
        }

        if (that.currentWithdrawSelectedTab === 'to-va-wallet') {
          const validateData = { virtualAccount: that.virtualAccount, accountRemark: that.accountRemark }
          that.virtualAccountData.forEach((account,index) => {
            if (account.currency) {
              account[`accountCurrencyStatus${index}`] = false
            } else {
              account[`accountCurrencyStatus${index}`] = true
            }
            validateData[`accountAmountWithdraw${index}`] = account.amount
          })
          that.$validator.validateAll(validateData).then((result) => {
            const isAllCurrencyFalse = that.virtualAccountData.every((bank,index) => !bank[`accountCurrencyStatus${index}`])
            if (!isAllCurrencyFalse) { return }
            // 每个 balance 都要大于 amount
            const isAllLessBalance = that.virtualAccountData.every((bank,index) => {
              return Number(bank.balance) >= Number(bank.amount)
            })
            if (!isAllLessBalance) { return }
            if (result) {
              const params = {
                "account": that.virtualAccount,
                "remark": that.accountRemark,
                "withdraw_requests": []
              }
              params.withdraw_requests = that.virtualAccountData.map(item => {
                return { amount: item.amount, currency: item.currency.value }
              })
              that.withdrawToVirtualRequest(params)
            }
          })
          return
        }

				if (!that.withdrawData.currency.value) {
					that.$message({ type: "error", message: 'Currency can not be empty' });
					return;
				}
				if (that.withdrawData.amount === '' || that.withdrawData.amount <= 0) {
					that.$message({ type: "error", message: 'Amount can not be empty' });
					return;
				}
				if (that.withdrawData.remark && that.withdrawData.remark.length > 200) {
					that.$message({ type: "error", message: 'The remark length cannot be greater than 200' });
					return;
				}

				// for (var variable of that.balance) {
				// 	console.log(that.balance);
				// 	for (var item in variable) {
				// 		console.log(item);
				// 		console.log(that.withdrawData);
				// 		// 这里有问题，variable是个数组，variable[item]并不能直接取到对应币种的金额
				// 		if (item === that.withdrawData.currency.value && that.withdrawData.amount > variable[item]) {
				// 			that.$message({type: "error", message: 'Insufficient Balance' });
				// 			return;
				// 		}
				// 	}
				// }
				if (that.withdrawTo.value === 'Payout Balance') {
					if (!that.payoutAccounts || !that.payoutAccounts.id) {
						that.$message({ type: "error", message: 'Payout Accounts can not be empty' });
						return;
					}
					if (!that.arrivedCurrency) {
						that.$message({ type: "error", message: 'Arrived Currency can not be empty' });
						return;
					}
				}
				that.$validator.validateAll({
          amount: that.withdrawData.amount,
          remark: that.withdrawData.remark
        }).then((result) => {
					if (that.checkWithdrawData() && result) {
						that.withdrawDialogVisible = false
						const access_token = localStorage.getItem("Authorization")
						let params = {
							amount: that.withdrawData.amount,
							currency: that.withdrawData.currency.value,
							fee_amount: that.withdrawData.fee_amount,
							fee_currency: that.withdrawData.fee_currency,
							remark: that.withdrawData.remark,
						}
						if (that.isPayout) {
							params.payout = that.isPayout
							params.account_id = that.payoutAccounts.account_id
							params.withdraw_token = that.withdrawToken
							params.arrival_currency = that.otherPayoutBean.target_currency
							params.arrival_amount = that.otherPayoutBean.target_amount
							params.exchange_rate = that.otherPayoutBean.exchange_rate
						}
						this.loadingFullScreen('exchangeRateLoading', 'loading', 'fa fa-hourglass-half')
						request({
							method: "post",
							url: `api/dashboard/merchant/assets/withdraw?access_token=${access_token}`,
							data: params,
							headers: {
								"Content-Type": "application/json"
							}
						})
							.then(res => {
								that.exchangeRateLoading.close()
								let data = res.data;
								if (data.code === "10000") {
									that.$message({
										type: "success",
										duration: 5000,
										message: data.msg
									});
									that.$refs.withdraw.close()
									that.queryRevenueList();
                  that.$refs.financeTabs.selectTab('#payout-history')
								} else {
									that.$message({
										type: "error",
										duration: 5000,
										message: data.msg
									});
								}
							})
							.catch(err => { });
					}
				})
			}
		},
		isCurrencyValid(field) {
			let isValid = false
			if (this.currencyStatus) {
				isValid = true
			}
			return isValid
		},
		isPayoutAccountsValid(field) {
			let isValid = false
			if (this.payoutAccountsStatus) {
				isValid = true
			}
			return isValid
		},
		isArrivedCurrencyValid(field) {
			let isValid = false
			if (this.arrivedCurrencyStatus) {
				isValid = true
			}
			return isValid
		},
		isFormFieldValid(field) {
			let isValid = false
			if (this.formFields[field]) {
				isValid =
					this.formFields[field].validated && this.formFields[field].valid
			}
			return isValid
		},
		checkWithdrawData() {
			let that = this
			let withdrawArray = ['currency']
			let isValidate = withdrawArray.reduce((result, current) => {
				if (!that.withdrawData[current]) {
					that[current + 'Status'] = true
				} else {
					that[current + 'Status'] = false
				}
				return result && !that[current + 'Status']
			}, true)
			return isValidate
		},
		withdrawToChange(item) {
			if (item.value === 'Payout Balance') {
				this.isBank = false
				this.isPayout = true
				this.payoutAccounts = {}
				this.arrivedCurrency = ''
				this.arrivedAmount = ""
				this.exchangeRate = ""
			} else {
				this.isBank = true
				this.isPayout = false
				// this.withdrawData.remark = ""
			}
		},
    withdrawToBankUniqueOne () {
      // Settlement Bank Account下拉有记录时，直接展示第一条数据和对应的WITHDRAW CURRENCY
      if (this.withdrawToBankOption.length > 0) {
        const { currency } = this.withdrawToBankOption[0]
        this.withdrawCurrency = { label: currency, value: currency }
        this.withdrawCurrencyChange(this.withdrawCurrency)
        this.withdrawToBank = this.withdrawToBankOption[0]
        this.withdrawToBankChange(this.withdrawToBank)
      } else {
        this.withdrawCurrency = { label: 'USD', value: 'USD' }
        this.withdrawCurrencyChange(this.withdrawCurrency)
      }
    },
		fetchBankAvailableList() {
			let that = this
			const access_token = localStorage.getItem("Authorization")
			request({
				method: "post",
				url: `api/dashboard/merchant/assets/batch-withdraw/bank-available-list?access_token=${access_token}`,
				headers: {
					"Content-Type": "application/json"
				}
			}).then(res => {
				let data = res.data;
				that.withdrawToBankOption = data.data
        that.withdrawToBankOption.forEach(item => {
          item.label = `${item.currency}-${item.account_number}-${item.bank_name}`
          item.value = item.id
        })
        that.withdrawToBankUniqueOne()
				// that.$message({
				// 	type: "success",
				// 	duration: 5000,
				// 	message: data.msg
				// });
			})
				.catch(err => { });
		},
		fetchPayoutAccounts() {
			let that = this
			const access_token = localStorage.getItem("Authorization")
			request({
				method: "post",
				url: `api/dashboard/merchant/assets/payout-accounts?access_token=${access_token}`,
				headers: {
					"Content-Type": "application/json"
				}
			}).then(res => {
				let data = res.data;
				that.payoutAccountsOptions = data.data
				// that.$message({
				// 	type: "success",
				// 	duration: 5000,
				// 	message: data.msg
				// });
			})
				.catch(err => { });
		},
		payoutAccountsChange(item) {
			if (item) {
        this.payoutAccounts = item
        if (this.withdrawData.currency && item.supported_currencies_map[this.withdrawData.currency.value]) {
          this.arrivedCurrencyOption = item.supported_currencies_map[this.withdrawData.currency.value]
        } else {
          this.arrivedCurrencyOption = []
        }
        this.arrivedCurrency = ''
			} else {
				this.payoutAccounts = {}
				this.arrivedCurrencyOption = []
				this.arrivedCurrency = ''
				this.arrivedAmount = ""
				this.exchangeRate = ""
			}
		},
    updateArrivedCurrencyOption(currency) {
      if (this.payoutAccounts && currency) {
        if (this.payoutAccounts.supported_currencies_map && this.payoutAccounts.supported_currencies_map[currency.value]) {
          this.arrivedCurrencyOption = this.payoutAccounts.supported_currencies_map[currency.value]
        } else {
          this.arrivedCurrencyOption = []
        }
      }
      this.arrivedCurrency = ''
    },
		generateExchangeRate() {
			if (this.withdrawData.currency && this.arrivedCurrency && this.withdrawData.amount) {
				// 获取商户Withdraw汇率
				this.fetchExchangeRate()
			} else {
				this.withdrawToken = ""
				this.arrivedAmount = ""
				this.exchangeRate = ""
				this.otherPayoutBean = {}
			}
		},
		fetchExchangeRate() {
			let that = this
			const access_token = localStorage.getItem("Authorization")
			this.loadingFullScreen('exchangeRateLoading', 'loading', 'fa fa-hourglass-half')
			request({
				method: "post",
				url: `api/dashboard/merchant/assets/withdraw/exchange-rate?access_token=${access_token}&source=${that.withdrawData.currency.value}&target=${that.arrivedCurrency}&amount=${that.withdrawData.amount}&payout_id=${that.payoutAccounts.id}`,
				headers: {
					"Content-Type": "application/json"
				}
			}).then(res => {
				that.exchangeRateLoading.close()
				if (res.data.code === "10000") {
					let data = res.data.data;
					that.withdrawToken = data.withdraw_token
					that.arrivedAmount = data.target_amount
					that.exchangeRate = data.exchange_rate
					that.otherPayoutBean = data
				} else {
					that.withdrawToken = ''
					that.arrivedAmount = 'Not set'
					that.exchangeRate = 'Not set'
					that.otherPayoutBean = {}
				}
			})
				.catch(err => { });
		},
		amountChange(item) {
			this.generateExchangeRate()
		},
		changeAmountValue() {
			this.withdrawData.amount = this.withdrawData.amount.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')
		},
		arrivedCurrencyChange(item) {
			this.generateExchangeRate()
		},
		loadingFullScreen(controller, txt, className) {
			this[controller] = this.$loading({
				lock: true,
				text: txt,
				spinner: className,
				background: 'rgba(0, 0, 0, 0.7)',
			})
		},
    isWithdrawCurrencyValid(field) {
			let isValid = false
			if (this.withdrawCurrencyStatus) {
				isValid = true
			}
			return isValid
		},
    isWithdrawToBankValid(field) {
			let isValid = false
			if (this.withdrawToBankStatus) {
				isValid = true
			}
			return isValid
		},
    isBankCurrencyValid(item) {
			let isValid = false
			if (item.bankCurrencyStatus) {
				isValid = true
			}
			return isValid
		},
    withdrawToBankChange(item) {
      const filterInfo = this.withdrawToBankOption.filter(bank => bank.id === item.value)[0]
      if (filterInfo) {
        this.accountInfo = filterInfo
      } else {
        this.accountInfo = {}
      }
    },
    withdrawCurrencyChange(item) {
      this.resetToBankForm()
      this.withdrawCurrency = item
      if (item.value === 'USD' || item.value === 'EUR') {
        this.isUSDEUR = true
      } else {
        const filterCurrency = this.newCurrencies.filter(currency => {
          return currency.value === item.value
        })[0]
        this.bankWithdrawData[0].currency = filterCurrency
        this.bankWithdrawData[0].balance = filterCurrency.balance
        this.isUSDEUR = false
      }
    },
    addBankCurrency(index) {
      const newData = {bankCurrencyStatus: false}
      this.bankWithdrawData.push(newData)
    },
    minusBankCurrency(index) {
      this.bankWithdrawData.splice(index, 1)
    }
	}
};
</script>
<style lang="scss" scoped>
@import "./components/financialManagement.scss";
/deep/ .withdraw-to-bank,/deep/ .withdraw-tobank-currency {
  .select-form-group {
    margin-bottom:0!important;
  }
  .scrollbar-wrapper {
    max-height: 200px !important;
  }
}
</style>
